import { ISubmission } from '@/components/interfaces';
import { GradingStatus, IStudent } from 'components/staffer/AssignmentsBasedGradesTable/types';

interface ApplyGradesFilterProps {
  gradingStatusFilter: GradingStatus[];
  students: IStudent[];
  submissions: ISubmission[];
}

export const applyGradesFilters = ({
  gradingStatusFilter,
  students,
  submissions,
}: ApplyGradesFilterProps) => {
  if (gradingStatusFilter.length === 0) return students;

  const studentIdMap = submissions.reduce((acc, submission) => {
    if (gradingStatusFilter.includes(submission.graded_status) && submission.user_type === 'Student') {
      acc[submission.user_id] = true;
    }
    return acc;
  }, {});

  return students.filter(student => studentIdMap[student.id]);
};
